import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let transactionIndex = () => import(/* webpackChunkName: "transaction" */ '@/views/financial/transactions/Index');
let invoiceIndex = () => import(/* webpackChunkName: "invoices" */ '@/views/financial/invoices/Index');
let invoiceShow = () => import(/* webpackChunkName: "invoices" */ '@/views/financial/invoices/Show');
let invoicePrint = () => import(/* webpackChunkName: "invoices" */ '@/views/financial/invoices/Print');
let receiptsIndex = () => import(/* webpackChunkName: "receipts" */ '@/views/financial/receipts/Index');
 export default [
    ...prefix("/financial", [
        {
            path: "transactions",
            name: "financial.transactions.index",
            component: transactionIndex,
            meta: {
                middleware: web,
                title: "تراکنش ها"
            }
        },
        {
            path: "invoices",
            name: "financial.invoices.index",
            component: invoiceIndex,
            meta: {
                middleware: web,
                title: "صورتحساب ها"
            }
        },
        {
            path: "invoices/:invoice",
            name: "financial.invoices.show",
            component: invoiceShow,
            meta: {
                middleware: web,
                title: ""
            },
        },
        {
            path: "invoices/:invoice/print",
            name: "financial.invoices.print",
            component: invoicePrint,
            meta: {
                middleware: web,
                title: "چاپ صورتحساب"
            },
        },
        {
            path: "receipts",
            name: "financial.receipts.index",
            component: receiptsIndex,
            meta: {
                middleware: web,
                title: "رسیدهای پرداخت"
            }
        },
    ])
]
